import React from "react";
import { useLocation } from "react-router-dom";
import { jsPDF } from "jspdf";
import "./BookingConfirmation.css";
import { Button } from "primereact/button";
import { LayoutMain } from "../../components/common";

const BookingConfirmation = () => {
  const location = useLocation();
  const templateParams = location.state?.templateParams;
  const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;

  if (!templateParams) {
    return <div>No booking details available.</div>;
  }

  {/*
   const handleDownload = () => {
    const doc = new jsPDF();

    // Set document title
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text("Buchungsbestätigung", 105, 30, null, null, "center");

    if (logo) {
      doc.addImage(logo, "PNG", 15, 10, 50, 30); // Adjust size and position as needed
    }

    // Add booking date
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Datum: ${new Date().toLocaleDateString("de-DE")}`, 160, 30);

    // Add booking details
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("Reise/Tour:", 20, 50);
    doc.setFont("helvetica", "normal");
    doc.text(templateParams.offer, 60, 50);

    doc.setFont("helvetica", "bold");
    doc.text("Anzahl der Personen:", 20, 60);
    doc.setFont("helvetica", "normal");
    doc.text(`${templateParams.numOfPeople}`, 60, 60);

    doc.setFont("helvetica", "bold");
    doc.text("Teilnehmer", 20, 70);
    doc.setFont("helvetica", "normal");
    doc.text(`${templateParams.participant1}`, 60, 70);
    doc.text(`${templateParams.participant2}`, 60, 75);

    doc.setFont("helvetica", "bold");
    doc.text("Stadt:", 20, 85);
    doc.setFont("helvetica", "normal");
    doc.text(templateParams.city, 60, 85);

    doc.setFont("helvetica", "bold");
    doc.text("PLZ:", 20, 115);
    doc.setFont("helvetica", "normal");
    doc.text(templateParams.zip, 60, 115);

    // Add Ort section
    doc.setFont("helvetica", "bold");
    doc.text("Ort:", 20, 125);
    doc.setFont("helvetica", "normal");
    doc.text(templateParams.state, 60, 125);

    doc.setFont("helvetica", "bold");
    doc.text("Telefonnummer:", 20, 95);
    doc.setFont("helvetica", "normal");
    doc.text(templateParams.telefonnumber, 60, 95);

    doc.setFont("helvetica", "bold");
    doc.text("E-Mail:", 20, 105);
    doc.setFont("helvetica", "normal");
    doc.text(templateParams.email, 60, 105);

    doc.setFont("helvetica", "bold");
    doc.text("Wunschdatum:", 20, 105);
    doc.setFont("helvetica", "normal");
    doc.text(templateParams.wishDate || "Kein Datum gewählt", 60, 105);

    doc.setFont("helvetica", "bold");
    doc.text("Anmerkungen:", 20, 115);
    doc.setFont("helvetica", "normal");
    doc.text(templateParams.remark || "Keine Anmerkungen", 60, 115);

    doc.setFont("helvetica", "bold");
    doc.text("AGB akzeptiert:", 20, 125);
    doc.setFont("helvetica", "normal");
    doc.text(templateParams.agb, 60, 125);

    doc.setFont("helvetica", "bold");
    doc.text("Datenschutz akzeptiert:", 20, 135);
    doc.setFont("helvetica", "normal");
    doc.text(templateParams.privacy, 60, 135);

    doc.setFont("helvetica", "bold");
    doc.text("Pauschalreiserichtlinie akzeptiert:", 20, 145);
    doc.setFont("helvetica", "normal");
    doc.text(templateParams.prv, 60, 145);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    const infoParagraph = `Bei der Ihnen angebotenen Kombination von Reiseleistungen handelt es sich um eine Pauschalreise im Sinne der Richtlinie (EU) 2015/2302. Daher können Sie alle EU-Rechte in Anspruch nehmen, die für Pauschalreisen gelten. Das KaMikaze Travel e.U. trägt die volle Verantwortung für die ordnungsgemäße Durchführung der gesamten Pauschalreise. Zudem verfügt das KaMikaze Travel e.U. über die gesetzlich vorgeschriebene Absicherung für die Rückzahlung Ihrer Zahlungen und, falls der Transport in der Pauschalreise inbegriffen ist, zur Sicherstellung Ihrer Rückbeförderung im Fall seiner Insolvenz.`;
    doc.text(infoParagraph, 20, 160, { maxWidth: 170 });

    // Add total price section
    doc.setFont("helvetica", "bold");
    doc.text("Gesamtpreis:", 20, 155);
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 255);
    doc.text(`EUR ${templateParams.totalPrice}`, 60, 155);

    // Add additional information
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    const additionalInfo = `Zur Bestätigung der Buchung, bitte die Anzahlung von 20% des Reisepreises auf das untenstehende Konto überweisen. Der Restbetrag kann 20 Tage vor Veranstaltungsbeginn beglichen werden. ACHTUNG: Diese Veranstaltung hat eine Mindest-Teilnehmerinnenanzahl. Sollte die Durchführung aufgrund zu weniger Teilnehmer:innen nicht möglich sein, überweisen wir Ihnen die bereits eingezahlten Beträge natürlich entsprechend auf das von Ihnen angegebene Konto zurück.`;
    doc.text(additionalInfo, 20, 170, { maxWidth: 170 });

    // Footer with company details
    doc.setFontSize(10);
    doc.text("KaMikaze Travel e.U.", 20, 240);
    doc.text(
      "www.kamikaze-travel.at | Firmenbuchnummer: FN 632918m | GISA-Kennzahl: 37406257",
      20,
      245
    );
    doc.text("Bankinstitut: Salzburger Sparkasse Bank AG", 20, 250);
    doc.text("IBAN: AT63 2040 4000 4357 9374 | BIC: SBGSAT2SXXX", 20, 255);
    doc.text("Schiliftstraße 504, 5753 Saalbach", 20, 260);
    doc.text(
      "E-Mail: info@kamikaze-travel.at | Mobil: +43 681 816 118 86",
      20,
      265
    );

    // Save the document
    doc.save("buchungsbestaetigung.pdf");
  };
*/}

  return (
    <LayoutMain>
      <div className="confirmation-wrapper">
        {/* Header */}
        <header className="confirmation-header">
          <img
            src={`${baseImagePath}logo/logo_bunt.png`}
            alt="kamikaze-travel-logo"
            className="company-logo"
          />
          <h1>KaMikaze Travel</h1>
        </header>

        <div className="thanks-note">
          <h2>Vielen Dank für deine Buchung!</h2>
        </div>
        <div className="booking-details">
          <h4>Angebot: {templateParams.offer}</h4>
          <p>Wunschdatum: {templateParams.wishDate || "Kein Datum gewählt"}</p>
          <p>Anzahl der Personen: {templateParams.numOfPeople}</p>
          <p>Teilnehmer: {templateParams.participants}</p>
          <p>Stadt: {templateParams.city}</p>
          <p>PLZ: {templateParams.zip}</p>
          <p>Ort: {templateParams.state}</p>
          <p>Telefonnummer: {templateParams.telefonnumber}</p>
          <p>E-Mail: {templateParams.email}</p>
          <p>Gesamtpreis: € {templateParams.totalPrice}</p>
          <p>Anmerkungen: {templateParams.remark || "Keine Anmerkungen"}</p>
          <p>AGB akzeptiert: {templateParams.agb}</p>
          <p>Datenschutz akzeptiert: {templateParams.privacy}</p>
          <p>Pauschalreiserichtlinie akzeptiert: {templateParams.prv}</p>
        </div>

        <div className="wishdate-info">
          <p>
            Solltest du einen Wunschtermin angegeben haben, dann gilt die
            Reise/Tour erst als final gebucht, wenn wir deinen Wunschtermin
            persönlich bestätigt haben. Dies erfolgt zeitnah telefonisch oder
            per E-Mail.
          </p>
        </div>

        {/* Footer */}
        <footer className="confirmation-footer">
          <p>
            <strong>KaMikaze Travel e.U.</strong>
          </p>
          <p>
            www.kamikaze-travel.at | Firmenbuchnummer: FN 632918m |
            GISA-Kennzahl: 37406257
          </p>
          <div className="footer-column">
            <p>Schiliftstraße 504, 5753 Saalbach-Hinterglemm</p>
            <p>E-Mail: info@kamikaze-travel.at</p>
            <p>Mobil: +43 681 816 118 86</p>
          </div>
          <div className="footer-column">
            <p>Bankinstitut: Salzburger Sparkasse Bank AG</p>
            <p>IBAN: AT63 2040 4000 4357 9374 </p>
            <p>BIC: SBGSAT2SXXX</p>
          </div>
          <p>© 2024 KaMikaze Travel - Alle Rechte vorbehalten</p>
        </footer>
      </div>
{/*
  <div className="button-container">
    <Button
      label="Buchungsbestätigung herunterladen"
      className="p-button-primary"
      onClick={handleDownload}
    />
  </div>
*/}
    </LayoutMain>
  );
};

export default BookingConfirmation;
